webpackJsonp([35],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 06/02/2017.
	 */
	var Shared = __webpack_require__(115);
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var LoginManager = __webpack_require__(149);
	var StorageController = __webpack_require__(123);
	
	//styles
	__webpack_require__(660);
	
	$(function () {
	  LanguageManager.init(function () {
	    storeLogin.init();
	  }, Shared.defaultLocale);
	});
	
	var storeLogin = {};
	
	(function (StoreLogin) {
	  StoreLogin.init = function () {
	    setUpEventListeners();
	  };
	
	  function setUpEventListeners() {
	    $("#register-btn").on("click", function (e) {
	      var qsReferer = utils.getQueryParam("referrer");
	
	      if (utils.isNullOrEmpty(qsReferer)) {
	        utils.redirect("/store/register");
	      } else {
	        utils.redirect("/store/register?referrer=" + qsReferer);
	      }
	    });
	
	    $("#password-input").on("keyup", function (e) {
	      if (e.keyCode === 13) {
	        handleLoginEvent();
	      }
	    });
	
	    $("#login-btn").on("click", function (e) {
	      handleLoginEvent();
	    });
	  }
	
	  function handleLoginEvent() {
	    var usernameEl = $("#username-input").removeClass("input-error"),
	        passwordEl = $("#password-input").removeClass("input-error"),
	        username = utils.removeWhitespace(usernameEl.val()),
	        password = utils.removeWhitespace(passwordEl.val()),
	        valid = true;
	
	    if (utils.isNullOrEmpty(username)) {
	      valid = false;
	      usernameEl.addClass("input-error");
	    }
	
	    if (utils.isNullOrEmpty(password)) {
	      valid = false;
	      passwordEl.addClass("input-error");
	    }
	
	    if (valid) {
	      login(username, password);
	    } else {
	      Shared.Dialog.showMessageDialog("store.login.dialog.empty_fields.title", "store.login.dialog.empty_fields.text");
	    }
	  }
	
	  function login(username, password) {
	    LoginManager.login(username, password, function (referer, loginData) {
	      StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, loginData);
	
	      var qsReferer = utils.getQueryParam("referrer");
	
	      if (utils.isNullOrEmpty(qsReferer)) {
	        qsReferer = "/store/catalog";
	      }
	
	      utils.redirect(qsReferer);
	    }, function () {
	      //Failed
	      console.error("Failed to login");
	      Shared.Dialog.showMessageDialog("store.login.dialog.failed.title", "store.login.dialog.failed.text");
	    });
	  }
	})(storeLogin);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 117
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ }),

/***/ 660:
259

});


// WEBPACK FOOTER //
// js/store-login.cc44873238f5f6986961.js